import React from 'react';

// ─── Helpers ─────────────────────────────────────────────────────────────────

const formatMoney = (value) => `₪${Number(value || 0).toFixed(2)}`;

// ─── Sub-component ────────────────────────────────────────────────────────────

const SummaryRow = ({ label, value, valueClass = '' }) => (
  <div className="flex items-center justify-between">
    <span className="text-gray-500 text-xs sm:text-sm">{label}</span>
    <span className={`text-xs sm:text-sm font-medium ${valueClass}`}>{value}</span>
  </div>
);

// ─── Component ────────────────────────────────────────────────────────────────

const OrderSummary = ({
  selectedCount,
  subtotal,
  creditUsed        = 0,
  remainingBeforeVat = 0,
  TAX_RATE,
  vat,
  total,
}) => {
  const hasCredit = Number(creditUsed)  > 0;
  const hasVat    = Number(vat)         > 0;
  const vatPct    = (Number(TAX_RATE || 0) * 100).toFixed(0);

  return (
    <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-4 sm:p-5 lg:p-6">

      <h3 className="text-base sm:text-lg font-semibold text-indigo-800 pb-3 sm:pb-4 mb-3 sm:mb-4 border-b border-gray-100">
        סיכום עסקה
      </h3>

      <div className="space-y-2 sm:space-y-3">
        <SummaryRow label="מספר שיעורים"  value={selectedCount} />
        <SummaryRow label="סכום ביניים"   value={formatMoney(subtotal)} />

        {hasCredit && (
          <>
            <SummaryRow
              label="זיכוי"
              value={`-${formatMoney(creditUsed)}`}
              valueClass="text-green-600"
            />
            <SummaryRow
              label='יתרה לחיוב לפני מע"מ'
              value={formatMoney(remainingBeforeVat)}
            />
          </>
        )}

        {hasVat && (
          <SummaryRow
            label={`מע"מ ${vatPct}%`}
            value={formatMoney(vat)}
          />
        )}
      </div>

      {/* Total */}
      <div className="flex items-center justify-between mt-4 sm:mt-5 pt-3 sm:pt-4 border-t border-gray-100">
        <span className="font-bold text-sm sm:text-base text-gray-800">סך הכל לתשלום</span>
        <span className="font-bold text-sm sm:text-base text-indigo-700">
          {formatMoney(total)}
        </span>
      </div>
    </div>
  );
};

export default OrderSummary;